/**
 * Samouczek 'Zmiana platnosci paragonu' (Kasa/Bank -> Platnosci zmiany, POS -> Paragony).
 * Ksztalt danych: patrz frontend/src/pomoc/samouczki/KONTRAKT.md
 */
const OBRAZ = (plik, opis) => ({ plik, opis });

// Dwa dzialy: sama poprawka (A) i drugie wejscie + slad w kasie (B). Reguly, KIEDY
// poprawka jest jeszcze mozliwa, sa w 'uwagi' - to one najczesciej zaskakuja kasjera.
const DZIALY = {
  A: { tytul: 'Poprawka formy płatności', opis: 'Nabiłeś gotówkę, a klient zapłacił kartą (albo odwrotnie)? Poprawisz to sam — ale tylko dziś, dopóki Twoja zmiana jest otwarta.' },
  B: { tytul: 'Drugie wejście i ślad w kasie', opis: 'To samo okno otworzysz też z listy paragonów w POS. Po zmianie sprawdzisz, że kasa się zgadza.' },
};

const ZMIANA_PLATNOSCI = {
  id: 'zmiana-platnosci',
  dzialy: DZIALY,
  tytul: 'Kasa/Bank — jak poprawić formę płatności paragonu (pomyłka gotówka/karta)',
  dlaKogo: 'Kasjerzy',
  czas: '3 minuty',
  pdf: '/instrukcje/zmiana-platnosci.pdf',
  wstep: 'Klient zapłacił kartą, a Ty odruchowo kliknąłeś „Gotówka” — albo odwrotnie. Paragon jest już zamknięty, '
    + 'ale w kasie leży zapis, że wpłynęła gotówka, której nie ma. Bez poprawki na koniec dnia gotówka się nie zgodzi. '
    + 'Ta funkcja pozwala zmienić formę płatności takiego paragonu — tylko w dniu sprzedaży i tylko dopóki Twoja zmiana kasowa jest otwarta.',
  kroki: [
    {
      n: 1,
      dzial: 'A',
      tytul: 'Wejdź w Kasa / Bank i kliknij „Płatności zmiany”',
      tresc: 'W menu po lewej wybierz „Kasa / Bank”, a potem zakładkę „Płatności zmiany”. '
        + 'U góry widzisz zielony pasek „Otwarta zmiana” z loginem kasjera i godziną otwarcia. '
        + 'Jeśli zamiast niego jest żółty pasek „Brak otwartej zmiany”, lista będzie pusta i nic nie poprawisz — '
        + 'zmiana musi być otwarta.',
      obraz: OBRAZ('/instrukcje/zmiana-platnosci-1-zakladka.jpg', 'Zakładka Płatności zmiany z zielonym paskiem otwartej zmiany'),
    },
    {
      n: 2,
      dzial: 'A',
      tytul: 'Znajdź swój paragon i kliknij „Zmień płatność”',
      tresc: 'Lista pokazuje dzisiejsze paragony z otwartej zmiany, najnowsze u góry: godzina, numer paragonu, kasjer, kwota, forma. '
        + 'Odszukaj swój po godzinie i kwocie. Niebieski przycisk „Zmień płatność” działa tylko przy paragonach, które da się poprawić. '
        + 'Szary przycisk oznacza, że tej transakcji nie zmienisz — najedź na niego, a zobaczysz powód '
        + '(płatność dzielona, kupon, faktura, zwrot albo cudzy paragon).',
      obraz: OBRAZ('/instrukcje/zmiana-platnosci-2-wiersz.jpg', 'Wiersz paragonu z przyciskiem Zmień płatność i szarym przyciskiem przy kuponie'),
    },
    {
      n: 3,
      dzial: 'A',
      tytul: 'Wybierz, jak klient zapłacił naprawdę',
      tresc: 'Otwiera się okno „Zmień płatność” z numerem paragonu. W ramce „Obecna forma płatności” widzisz, jak paragon jest nabity teraz, '
        + 'obok kwotę. Pod spodem w „Nowa forma płatności” są tylko formy inne niż obecna: gotówka, karta, BLIK, przelew. '
        + 'Kliknij właściwą — zrobi się zielona.',
      obraz: OBRAZ('/instrukcje/zmiana-platnosci-3-okno.jpg', 'Okno Zmień płatność z obecną formą gotówka i wybraną nową formą karta'),
    },
    {
      n: 4,
      dzial: 'A',
      tytul: 'Wpisz powód i zatwierdź',
      tresc: 'W polu „Powód” napisz krótko, co się stało, np. „Klient płacił kartą, nabito gotówkę”. Minimum 5 znaków — '
        + 'bez powodu przycisk zostaje szary. Potem kliknij „Zmień płatność” w prawym dolnym rogu okna. '
        + 'Pojawi się zielony komunikat, np. „Płatność PAR/0017/09/2026/KAL: gotówka → karta”, a okno się zamknie. '
        + '„Anuluj” zamyka okno bez żadnej zmiany.',
      obraz: OBRAZ('/instrukcje/zmiana-platnosci-4-powod.jpg', 'Wypełnione pole Powód i aktywny przycisk Zmień płatność'),
    },
    {
      n: 5,
      dzial: 'A',
      tytul: 'Paragon z „F”: zaznacz potwierdzenie fiskalne',
      tresc: 'Jeśli w kolumnie FISKALNY paragon ma zielone „F”, w oknie pojawia się czerwona ramka: '
        + '„Paragon fiskalny jest już wydrukowany z formą gotówka”. Musisz zaznaczyć „Rozumiem, paragon fiskalny zostaje z formą gotówka” — '
        + 'bez tego nie zatwierdzisz. Co to znaczy: wydruk z drukarki fiskalnej się NIE zmienia, na rolce nadal stoi stara forma. '
        + 'Zmienia się tylko zapis w systemie i w kasie. To normalne — dokumentu fiskalnego nie da się cofnąć, a kasa ma się zgadzać z tym, co naprawdę wpłynęło.',
      obraz: OBRAZ('/instrukcje/zmiana-platnosci-5-fiskalny.jpg', 'Czerwona ramka ostrzeżenia dla paragonu zafiskalizowanego z polem potwierdzenia'),
    },
    {
      n: 6,
      dzial: 'A',
      tytul: 'Sprawdź wynik na liście',
      tresc: 'Lista odświeża się sama. Przy paragonie w kolumnie FORMA widzisz nową formę, a pod nią szary dopisek '
        + '„korekta: gotówka → karta” — ślad, że była poprawka. Kwoty w boksach u góry (Gotówka, Karta) też się przeliczają. '
        + 'Pomyłka w drugą stronę? Kliknij „Zmień płatność” jeszcze raz i wybierz poprzednią formę — każda zmiana zostaje w historii.',
      obraz: OBRAZ('/instrukcje/zmiana-platnosci-6-po-zmianie.jpg', 'Wiersz paragonu po zmianie: forma karta i dopisek korekta gotówka → karta'),
    },
    {
      n: 7,
      dzial: 'B',
      tytul: 'Albo z POS: „Paragony” → „...” → „💱 Płatność”',
      tresc: 'Nie musisz wychodzić z kasy. W POS kliknij u góry zakładkę „Paragony”, znajdź paragon na liście, '
        + 'kliknij przycisk „...” w kolumnie Akcje i wybierz „💱 Płatność”. System najpierw sprawdza, czy zmiana jest możliwa: '
        + 'jeśli nie, zobaczysz czerwony komunikat z powodem, a pozycja zrobi się szara. Jeśli tak — otworzy się to samo okno co w krokach 3–5.',
      obraz: OBRAZ('/instrukcje/zmiana-platnosci-7-pos-menu.jpg', 'Menu ... przy paragonie w POS z pozycją Płatność'),
    },
    {
      n: 8,
      dzial: 'B',
      tytul: 'Zobacz ślad w kasie: „Dokumenty KP”',
      tresc: 'Każda sprzedaż ma w kasie jeden wpis KP z numerem paragonu. Po zmianie płatności ten wpis zmienia formę — '
        + 'w Kasa / Bank, zakładka „Dokumenty KP”, przy numerze Twojego paragonu w kolumnie PŁATNOŚĆ stoi już „Karta”. '
        + 'Dzięki temu gotówka w kasie nie jest zawyżona i przy zamknięciu zmiany kwoty się zgodzą. '
        + 'Adnotacja z powodem, loginem i godziną trafia też do uwag transakcji i do historii.',
      obraz: OBRAZ('/instrukcje/zmiana-platnosci-8-kp.jpg', 'Zakładka Dokumenty KP z wpisem paragonu w formie Karta'),
    },
  ],
  uwagi: [
    'Tylko dziś i tylko w otwartej zmianie. Liczy się data z serwera, nie z Twojego zegarka. Po zamknięciu zmiany albo dnia poprawka znika bezpowrotnie — następnego dnia nie cofniesz nawet oczywistej pomyłki. Sprawdź formy płatności PRZED zamknięciem zmiany.',
    'Tylko własne paragony. Kasjer poprawia wyłącznie to, co sam nabił w swojej otwartej zmianie. Cudzy paragon ma szary przycisk „Mozesz zmieniac platnosc tylko wlasnych transakcji” — poprawi go kierownik z uprawnieniami administratora.',
    'Tylko czyste formy: gotówka, karta, BLIK, przelew — jedna na drugą. Nie zmienisz płatności dzielonej, płatności kuponem ani paragonu z kuponem, paragonu do faktury firmowej ani transakcji, do której był już zwrot. Jeśli klient zwrócił towar, forma zostaje.',
    'To narzędzie do naprawy własnych pomyłek, nie do „kombinowania” z gotówką. Każda zmiana zapisuje kto, kiedy, z czego na co i z jakim powodem — widać ją na liście („korekta: …”), w uwagach transakcji i w historii. Zmieniaj tylko wtedy, gdy klient naprawdę zapłacił inaczej, niż nabiłeś.',
    'Paragon fiskalny zostaje z wydrukowaną formą. Jeśli klient dostał paragon z napisem „gotówka”, a zapłacił kartą, po zmianie w systemie będzie „karta”, ale rolka się nie zmieni. Nie drukuj paragonu drugi raz.',
  ],
};

export default ZMIANA_PLATNOSCI;
